import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { IInlineElement, InlineConfirmContainer } from './inline-confirm-container';

@autoinject
export class InlineConfirmButton implements IInlineElement {
	@bindable type: string;
	@bindable buttonType: string;
	@bindable otherClasses: string[];
	@bindable label: string;
	@bindable question: string;
	@bindable size: string;
	@bindable proceedType: string;
	@bindable proceedLabel: string;
	@bindable cancelLabel: string;
	@bindable proceeding: () => void;

	visible = true;
	confirmVisible = false;

	constructor(private container: InlineConfirmContainer) {
		container.addElement(this);
	}

	@computedFrom('buttonType')
	get buttonTypeClass() {
		if (!this.buttonType) {
			return 'btn-default';
		}

		return `btn-${this.buttonType.toLowerCase()}`;
	}

	@computedFrom('size')
	get sizeClass() {
		if (!this.size || this.size === 'md') {
			return '';
		}

		return `btn-${this.size.toLowerCase()}`;
	}

	@computedFrom('otherClasses')
	get otherCssClasses() {
		if (this.otherClasses == null || this.otherClasses.length === 0) {
			return '';
		}

		return this.otherClasses.join(' ');
	}

	@computedFrom('proceedType')
	get proceedButtonClass() {
		if (!this.proceedType) {
			return 'btn-default';
		}

		return `btn-${this.proceedType.toLowerCase()}`;
	}

	showConfirm() {
		this.confirmVisible = true;
		this.container.hideElementsExcept(this);
	}

	hideConfirm() {
		this.confirmVisible = false;
		this.container.showElements();
	}

	hide() {
		this.visible = false;
	}

	show() {
		this.visible = true;
	}

	proceed() {
		if (this.proceeding != null) {
			this.proceeding();
		}

		this.hideConfirm();
	}
}
